import Vue from "vue";
import { INotificationOnClickResult, Notification } from "./notification";
import { AuthService } from "@/services";

export class DossierDataMissingNotification extends Notification {
	public async onClick(vue: Vue): Promise<INotificationOnClickResult> {
		return {
			routeTo: `/settings/company/dossier/${AuthService.wfDossier.id}`
		};
	}

	public getIcon():string {
		return "exclamation-circle";
	}

	public getTone():string {
		return "warning";
	}

	public getActionKey():string {
		return "open-settings";
	}
}
